import { NextSeo, NextSeoProps } from 'next-seo';
interface SeoProps extends NextSeoProps {
  url: string;
}
const Seo = ({ title, description, url, ...props }: SeoProps) => {
  return (
    <NextSeo
      title={title}
      description={description}
      openGraph={{
        url: `${process.env.NEXT_PUBLIC_WEBSITE_URL}${url.startsWith('/') ? url : `/${url}`}`,
        title,
        description,
      }}
      nofollow={process.env.NEXT_PUBLIC_IS_SAFE === 'true' ? true : false}
      noindex={process.env.NEXT_PUBLIC_IS_SAFE === 'true' ? true : false}
      twitter={{
        handle: '@PromptsClub',
        site: '@PromptsClub',
        cardType: 'summary_large_image',
      }}
      {...props}
    />
  );
};

export default Seo;
